import { styled } from '../Theme';

export const Box = styled('div', {});
